var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadAgree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 32C62 32.5 62 33 62 33.5C61.2 48.9 48.8 61.3 33.4 62C32.9 62 32.5 62 32 62C15.4 62 2 48.6 2 32C2 15.4 15.4 2 32 2C48.6 2 62 15.4 62 32Z",
    fill: "#2980B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62 33.5C61.2 48.9 48.8 61.3 33.4 62L15.2 43.8L48.5 20L62 33.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24V40C50 43.3 47.3 46 44 46H20C16.7 46 14 43.3 14 40V24C14 20.7 16.7 18 20 18H44C47.3 18 50 20.7 50 24Z",
    fill: "#FC6042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50 37.6V40C50 43.3 47.3 46 44 46H24.4L20.2 41.8L21.7 32.3L30.2 40.8L36 41L32 37L32.8 20.4L50 37.6Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42H21C20.4 42 20 41.6 20 41V33C20 32.4 20.4 32 21 32C21.6 32 22 32.4 22 33V40H42V33C42 32.4 42.4 32 43 32C43.6 32 44 32.4 44 33V41C44 41.6 43.6 42 43 42Z",
    fill: "#FFE7C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36C31.4 36 31 35.6 31 35V21C31 20.4 31.4 20 32 20C32.6 20 33 20.4 33 21V35C33 35.6 32.6 36 32 36Z",
    fill: "#FFE7C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37C31.7 37 31.5 36.9 31.3 36.7L27.3 32.7C26.9 32.3 26.9 31.7 27.3 31.3C27.7 30.9 28.3 30.9 28.7 31.3L32 34.6L35.3 31.3C35.7 30.9 36.3 30.9 36.7 31.3C37.1 31.7 37.1 32.3 36.7 32.7L32.7 36.7C32.5 36.9 32.3 37 32 37Z",
    fill: "#FFE7C1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAgree);
export default __webpack_public_path__ + "static/media/downloadAgree.a0150dcdd4d3e706e7352f954775ec54.svg";
export { ForwardRef as ReactComponent };